import { Injectable } from '@angular/core';

@Injectable()
export class BsDatepickerConfig {}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
